import React from "react";

export const BooksIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 5.00052C9 4.7353 8.89464 4.48095 8.70711 4.29341C8.51957 4.10588 8.26522 4.00052 8 4.00052H6C5.73478 4.00052 5.48043 4.10588 5.29289 4.29341C5.10536 4.48095 5 4.7353 5 5.00052V19.0005C5 19.2657 5.10536 19.5201 5.29289 19.7076C5.48043 19.8952 5.73478 20.0005 6 20.0005H8C8.26522 20.0005 8.51957 19.8952 8.70711 19.7076C8.89464 19.5201 9 19.2657 9 19.0005M9 5.00052V19.0005M9 5.00052C9 4.7353 9.10536 4.48095 9.29289 4.29341C9.48043 4.10588 9.73478 4.00052 10 4.00052H12C12.2652 4.00052 12.5196 4.10588 12.7071 4.29341C12.8946 4.48095 13 4.7353 13 5.00052V19.0005C13 19.2657 12.8946 19.5201 12.7071 19.7076C12.5196 19.8952 12.2652 20.0005 12 20.0005H10C9.73478 20.0005 9.48043 19.8952 9.29289 19.7076C9.10536 19.5201 9 19.2657 9 19.0005M5 8.00052H9M9 16.0005H13M14 9.00052L18 8.00052M16 16.0005L19.923 15.0205M13.8031 4.56053L15.9871 4.03053C16.5491 3.89553 17.1201 4.22053 17.2691 4.76253L20.9641 18.1805C21.0293 18.4262 21.0004 18.6873 20.8831 18.9128C20.7659 19.1383 20.5686 19.3119 20.3301 19.3995L20.1971 19.4405L18.0131 19.9705C17.4511 20.1055 16.8801 19.7805 16.7311 19.2385L13.0361 5.82053C12.9709 5.57488 12.9998 5.31374 13.117 5.08826C13.2343 4.86278 13.4315 4.68921 13.6701 4.60153L13.8031 4.56053Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
